import { render, staticRenderFns } from "./InplayList2.vue?vue&type=template&id=4ea9f35b&scoped=true"
import script from "./InplayList2.vue?vue&type=script&lang=js"
export * from "./InplayList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9f35b",
  null
  
)

export default component.exports